module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-26.ae525a96.svg";